module.exports = __webpack_public_path__ + "img/icons-cross.52658f61.svg";